import { createFileRoute, useNavigate, useRouter } from '@tanstack/react-router'
import dismissIcon from "@/assets/paytm/dismiss.png"
import walletIcon from "@/assets/paytm/wallet.png"
import errorIcon from "@/assets/paytm/error.png"
import DeliveryOption from '@/components/features/paytm/delivery-option'
import { LocationAddress, Quote } from '@/lib/interfaces'
import Button from '@/components/features/paytm/button'
import { generateOtp } from '@/lib/utils'
import { useStore } from '@/store'
import { useShallow } from 'zustand/shallow'

export const Route = createFileRoute('/shikhar/neworder/delivery-options')({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>): {
        rechargeWallet: boolean,
        lowBalanceWarning: boolean,
        quotes: Quote[]
        quoteId: string
        walletBalance: number,
        storeId: string,
        customerLocation: LocationAddress
    } => {
        return {
            rechargeWallet: search.rechargeWallet as boolean || false,
            lowBalanceWarning: search.lowBalanceWarning as boolean || false,
            quotes: search.quotes as Quote[] || [],
            quoteId: search.quoteId as string || '',
            walletBalance: search.walletBalance as number,
            storeId: search.storeId as string,
            customerLocation: search.customerLocation as LocationAddress
        }
    }
})

function RouteComponent() {
    const router = useRouter()
    const navigate = useNavigate()
    const {setPaytmTab} = useStore(useShallow(state => ({setPaytmTab: state.setPaytmTab})))
    
    const { rechargeWallet, lowBalanceWarning, quotes, quoteId, walletBalance, storeId, customerLocation } = Route.useSearch()
    const showWalletAlert = rechargeWallet || lowBalanceWarning

    return <div className="fixed left-0 right-0 top-0 bottom-0 bg-black/50 z-30">
        <div className={`absolute bottom-0 ${showWalletAlert ? 'h-[380px]' : 'h-[300px]'} bg-white left-0 right-0 rounded-tl-2xl rounded-tr-2xl`}>
            <div className="absolute w-full top-[10px] h-[60px] flex items-center justify-between px-[20px] font-semibold text-2xl">
                <p>Delivery Options</p>
                <img src={dismissIcon} className="w-[32px] absolute right-3 top-0" onClick={() => router.history.back()} />
            </div>
            <div className="absolute left-0 top-[60px] bottom-[90px] right-0 overflow-auto  p-[16px] *:mb-[16px]">
                <DeliveryOption quotes={quotes} sortQuotesByPrice />
            </div>
            <div className="absolute bottom-0 shadow-3xl flex p-[16px] w-full justify-between">
                {rechargeWallet ? (
                    <div className="w-full">
                        <div className="flex items-center">
                            <img src={walletIcon} className="w-6 mr-1" />
                            <p className="text-dark-midnight text-sm font-semibold">{`Available Wallet Balance: ₹ ${walletBalance?.toFixed(2) || 0}`}</p>
                        </div>
                        <div className="flex items-center p-1.5 rounded-xl bg-error-background my-3">
                            <img src={errorIcon} className="w-4 mr-1" />
                            <p className="text-xs font-medium">Insufficient wallet balance.</p>
                        </div>
                        <Button title='Add money in wallet' onClick={() => setPaytmTab('Wallet-U')}/>
                    </div>
                ) : (
                    <div className="w-full">
                        {lowBalanceWarning ? (
                            <>
                                <div className="flex items-center">
                                    <img src={walletIcon} className="w-6 mr-1" />
                                    <p className="text-dark-midnight text-sm font-semibold">{`Available Wallet Balance: ₹ ${walletBalance?.toFixed(2) || 0}`}</p>
                                </div>
                                <div className="flex items-center p-1.5 rounded-xl bg-error-background my-3">
                                    <img src={errorIcon} className="w-4 mr-1" />
                                    <p className="text-xs font-medium">Low balance.Please recharge.</p>
                                </div>
                            </>
                        ) : null}
                        <Button title="Next" onClick={() => {
                            navigate({to: '/shikhar/neworder/confirm', search: {
                                dropOtp: generateOtp(),
                                rtoOtp: generateOtp(),
                                quotes,
                                quoteId,
                                walletBalance,
                                storeId,
                                customerLocation
                            }})
                        }} />
                    </div>
                )}
            </div>
        </div>
    </div>
}
